import Lottie from 'lottie-react';
import animationData from 'assets/lottie/stars-donut.json';

export const StarsDonut = () => {
  return <Lottie animationData={animationData} height={142} width={142} loop autoplay />;
};
